var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLCubIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 260,
    viewBox: "0 0 263 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.075 117.766L197.537 191.073L118.961 74.2806L169.901 13.4632L240.075 117.766Z",
    fill: "#4639E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7203 224.535L16.259 122.778L83.0692 57.8891L169.913 13.525L118.658 73.697L197.38 190.705L84.7203 224.535Z",
    fill: "url(#paint0_angular_802_367)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_802_367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.563 40.8029) rotate(154.599) scale(218.481 219.273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000797948,
    stopColor: "#A9ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890579,
    stopColor: "#E2E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15175C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLCubIc);
export default __webpack_public_path__ + "static/media/lCub_ic.b83245ccd706f35efa3c348dd879265b.svg";
export { ForwardRef as ReactComponent };